<main class="c-main dashboard">
  <div class="container-fluid">

    <!-- Filtros -->
    <mat-card class="dashboard__filtros mb-3">
      <div class="dashboard__filtros-row">
        <div class="dashboard__presets">
          <button *ngFor="let p of presets" type="button" mat-stroked-button
            [class.dashboard__preset--ativo]="presetAtivo === p.dias" (click)="aplicarPreset(p.dias)">
            {{ p.label }}
          </button>
        </div>

        <div class="dashboard__datas">
          <mat-form-field appearance="fill" class="dashboard__campo">
            <mat-label>De</mat-label>
            <input matInput type="date" [(ngModel)]="dataInicio" (change)="onFiltroManual()">
          </mat-form-field>
          <mat-form-field appearance="fill" class="dashboard__campo">
            <mat-label>Até</mat-label>
            <input matInput type="date" [(ngModel)]="dataFim" (change)="onFiltroManual()">
          </mat-form-field>
          <mat-form-field appearance="fill" class="dashboard__campo" *ngIf="tem('TICKET')">
            <mat-label>Segmento</mat-label>
            <mat-select [(ngModel)]="filtroSegmento" (selectionChange)="onSegmentoChange()">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option *ngFor="let s of segmentos" [value]="s.codigo">{{ s.nome }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="dashboard__auto">
          <span class="dashboard__auto-chip" matTooltip="A dashboard atualiza automaticamente">
            <mat-icon>autorenew</mat-icon>
            Atualiza em {{ segundosRestantes }}s
          </span>
          <span class="dashboard__atualizado" *ngIf="ultimaAtualizacao">
            Atualizado às {{ ultimaAtualizacao | date:'HH:mm:ss' }}
          </span>
        </div>
      </div>
    </mat-card>

    <div *ngIf="carregando" class="dashboard__loading">Carregando informações...</div>

    <ng-container *ngIf="resumo">

      <!-- ███ CLIENTES ███ -->
      <ng-container *ngIf="tem('CLIENTE')">
        <h2 class="dashboard__secao"><mat-icon>people_outline</mat-icon> Clientes</h2>
        <div class="row g-3 mb-2">
          <div class="col-6 col-md-3">
            <div class="kpi kpi--roxo">
              <span class="kpi__label">Total de clientes</span>
              <span class="kpi__valor">{{ resumo.clientes.total }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--verde">
              <span class="kpi__label">Ativos</span>
              <span class="kpi__valor">{{ resumo.clientes.ativos }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--cinza">
              <span class="kpi__label">Inativos</span>
              <span class="kpi__valor">{{ resumo.clientes.inativos }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--azul">
              <span class="kpi__label">Novos no período</span>
              <span class="kpi__valor">{{ resumo.clientes.novosNoPeriodo }}</span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- ███ FINANCEIRO ███ -->
      <ng-container *ngIf="exibeFinanceiro">
        <h2 class="dashboard__secao"><mat-icon>account_balance_wallet</mat-icon> Financeiro</h2>
        <div class="row g-3 mb-2">
          <div class="col-12 col-md-6" *ngIf="tem('CONTA_RECEBER')">
            <div class="kpi-fin kpi-fin--receber">
              <div class="kpi-fin__head">
                <mat-icon>trending_up</mat-icon> Contas a Receber
              </div>
              <div class="kpi-fin__grid">
                <div>
                  <span class="kpi__label">Em aberto</span>
                  <span class="kpi__valor">{{ formatarMoeda(resumo.contaReceber.totalEmAberto) }}</span>
                  <span class="kpi__sub">{{ resumo.contaReceber.qtdEmAberto }} conta(s)</span>
                </div>
                <div>
                  <span class="kpi__label">Vencido</span>
                  <span class="kpi__valor kpi__valor--alerta">{{ formatarMoeda(resumo.contaReceber.totalVencido) }}</span>
                  <span class="kpi__sub">{{ resumo.contaReceber.qtdVencido }} conta(s)</span>
                </div>
                <div>
                  <span class="kpi__label">Recebido no período</span>
                  <span class="kpi__valor kpi__valor--ok">{{ formatarMoeda(resumo.contaReceber.totalLiquidadoNoPeriodo) }}</span>
                  <span class="kpi__sub">{{ resumo.contaReceber.qtdLiquidadoNoPeriodo }} baixa(s)</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6" *ngIf="tem('CONTA_PAGAR')">
            <div class="kpi-fin kpi-fin--pagar">
              <div class="kpi-fin__head">
                <mat-icon>trending_down</mat-icon> Contas a Pagar
              </div>
              <div class="kpi-fin__grid">
                <div>
                  <span class="kpi__label">Em aberto</span>
                  <span class="kpi__valor">{{ formatarMoeda(resumo.contaPagar.totalEmAberto) }}</span>
                  <span class="kpi__sub">{{ resumo.contaPagar.qtdEmAberto }} conta(s)</span>
                </div>
                <div>
                  <span class="kpi__label">Vencido</span>
                  <span class="kpi__valor kpi__valor--alerta">{{ formatarMoeda(resumo.contaPagar.totalVencido) }}</span>
                  <span class="kpi__sub">{{ resumo.contaPagar.qtdVencido }} conta(s)</span>
                </div>
                <div>
                  <span class="kpi__label">Pago no período</span>
                  <span class="kpi__valor kpi__valor--ok">{{ formatarMoeda(resumo.contaPagar.totalLiquidadoNoPeriodo) }}</span>
                  <span class="kpi__sub">{{ resumo.contaPagar.qtdLiquidadoNoPeriodo }} baixa(s)</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-12">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Fluxo dos últimos 6 meses (por vencimento)</h3>
              <canvas id="chartFluxo"></canvas>
            </mat-card>
          </div>
        </div>
      </ng-container>

      <!-- ███ TICKETS ███ -->
      <ng-container *ngIf="tem('TICKET')">
        <h2 class="dashboard__secao"><mat-icon>support_agent</mat-icon> Tickets</h2>
        <div class="row g-3 mb-2">
          <div class="col-6 col-md-3">
            <div class="kpi kpi--roxo">
              <span class="kpi__label">Total</span>
              <span class="kpi__valor">{{ resumo.tickets.total }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--laranja">
              <span class="kpi__label">Em aberto</span>
              <span class="kpi__valor">{{ resumo.tickets.abertos }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--verde">
              <span class="kpi__label">Finalizados</span>
              <span class="kpi__valor">{{ resumo.tickets.finalizados }}</span>
            </div>
          </div>
          <div class="col-6 col-md-3">
            <div class="kpi kpi--azul">
              <span class="kpi__label">Novos no período</span>
              <span class="kpi__valor">{{ resumo.tickets.novosNoPeriodo }}</span>
            </div>
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-12 col-md-4">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Tickets por status</h3>
              <canvas id="chartTicketStatus"></canvas>
            </mat-card>
          </div>
          <div class="col-12 col-md-4">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Tickets por prioridade</h3>
              <canvas id="chartTicketPrioridade"></canvas>
            </mat-card>
          </div>
          <div class="col-12 col-md-4">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Tickets por tipo</h3>
              <canvas id="chartTicketTipo"></canvas>
              <p *ngIf="!resumo.tickets.porTipo?.length" class="dashboard__sem-dados">Sem dados no período.</p>
            </mat-card>
          </div>
        </div>

        <div class="row g-3 mb-2">
          <div class="col-12 col-md-6">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Ranking de responsáveis</h3>
              <canvas id="chartTicketResponsavel"></canvas>
              <p *ngIf="!resumo.tickets.porResponsavel?.length" class="dashboard__sem-dados">Sem dados no período.</p>
            </mat-card>
          </div>
          <div class="col-12 col-md-6">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Tickets por segmento</h3>
              <canvas id="chartTicketSegmento"></canvas>
              <p *ngIf="!resumo.tickets.porSegmento?.length" class="dashboard__sem-dados">Sem dados no período.</p>
            </mat-card>
          </div>
        </div>

        <div class="row g-3 mb-4">
          <div class="col-12">
            <mat-card class="dashboard__chart">
              <h3 class="dashboard__chart-titulo">Top clientes por tickets</h3>
              <canvas id="chartTicketCliente"></canvas>
              <p *ngIf="!resumo.tickets.porCliente?.length" class="dashboard__sem-dados">Sem dados no período.</p>
            </mat-card>
          </div>
        </div>
      </ng-container>

      <div *ngIf="!tem('CLIENTE') && !exibeFinanceiro && !tem('TICKET')" class="dashboard__vazio">
        <mat-icon>info</mat-icon>
        <p>Você não possui módulos com indicadores disponíveis no seu perfil.</p>
      </div>

    </ng-container>
  </div>
</main>
